<mat-card class="form-dialogo">
  <app-card-header
    [title]="title"
    [subtitle]="subtitle"
    icono="personal_injury"
    [draggable]="true"
    [botonCerrar]="true"
    (cerrar)="close()"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <mat-card-content class="card-content-crear">
        <!-- Input falso: Chrome autocompleta esto y no los datos del paciente -->
        <input
          type="password"
          style="display: none"
          autocomplete="new-password"
        />

        <!-- Datos personales -->
        <app-content-card
          title="Datos del paciente"
          icon="personal_injury"
          color="blue"
        >
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="nombre" autocomplete="nope" />
              <mat-icon matPrefix>person</mat-icon>
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>Apellido</mat-label>
              <input matInput formControlName="apellido" autocomplete="nope" />
              <mat-icon matPrefix>person_outline</mat-icon>
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>DNI</mat-label>
              <input matInput formControlName="dni" autocomplete="nope" />
              <mat-icon matPrefix>badge</mat-icon>
            </mat-form-field>
          </section>

          <section class="inputs-group">
            <ng-select
              style="width: 100%"
              formControlName="sexo"
              placeholder="Sexo"
              [items]="sexos"
              bindLabel="label"
              bindValue="value"
              [clearable]="true"
              appendTo="body"
              notFoundText="Sin resultados"
            ></ng-select>

            <mat-form-field style="width: 100%">
              <mat-label>Edad</mat-label>
              <input
                matInput
                type="number"
                min="0"
                max="130"
                formControlName="edad"
                autocomplete="nope"
              />
              <mat-icon matPrefix>cake</mat-icon>
              <span matTextSuffix>años</span>
              @if (form.get('edad')?.invalid) {
                <mat-error>Ingresá una edad entre 0 y 130</mat-error>
              }
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>Obra social</mat-label>
              <input
                matInput
                formControlName="obraSocial"
                autocomplete="nope"
              />
              <mat-icon matPrefix>health_and_safety</mat-icon>
            </mat-form-field>
          </section>

          @if (mostrarCliente && !id) {
            <section class="inputs-group">
              <app-cliente-selector
                formControlName="idCliente"
                style="width: 100%"
                [filterModules]="['moduloEmergenciasMedicas']"
                [showCrearBtn]="
                  helper.tienePermiso('Administración - Crear clientes')
                "
              ></app-cliente-selector>
            </section>
          }
        </app-content-card>

        <!-- Contacto -->
        <app-content-card title="Contacto" icon="contacts" color="green">
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Teléfono</mat-label>
              <input matInput formControlName="telefono" autocomplete="nope" />
              <mat-icon matPrefix>phone</mat-icon>
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>Teléfono alternativo</mat-label>
              <input
                matInput
                formControlName="telefonoAlternativo"
                autocomplete="nope"
              />
              <mat-icon matPrefix>phone_android</mat-icon>
            </mat-form-field>

            <mat-form-field style="width: 100%">
              <mat-label>Email</mat-label>
              <input
                matInput
                type="email"
                formControlName="email"
                autocomplete="nope"
              />
              <mat-icon matPrefix>email</mat-icon>
              @if (form.get('email')?.hasError('email')) {
                <mat-error>Ingresá un email válido</mat-error>
              }
            </mat-form-field>
          </section>
        </app-content-card>

        <!-- Información adicional -->
        <app-content-card
          title="Información adicional"
          icon="notes"
          color="purple"
        >
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Antecedentes, alergias, medicación…</mat-label>
              <textarea
                matInput
                rows="3"
                formControlName="descripcion"
                autocomplete="nope"
              ></textarea>
              <mat-icon matPrefix>medical_information</mat-icon>
            </mat-form-field>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="close()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
          [disabled]="!form.valid || guardando"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario…" [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
